import type { ListProduct } from '@/queries/Products';

export const getPriceAndDiscount = (data: ListProduct | undefined) => {
  const comparePrice = data?.comparePrice?.amount;
  const price = comparePrice ?? data?.price?.amount;
  const discount = data?.discountedPrice.discountedPrice?.amount;
  const discountPrice = price && discount ? price - discount : 0;
  return { discountPrice, price };
};
